/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");





//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/es6.object.to-string.js
// module id = 198
// module chunks = 76